<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container">
                <div class="modal-header">
					<div class="modal-title">
						Вы не добавили получателей
					</div>
					<div class="modal-header__close-button" @click="closeModal">
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M18 6L6 18M6 6L18 18" stroke="#A8A8A8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
					</div>
                </div>
				<div class="modal-body">
					Вы пытаетесь сохранить отправление без указанных получателей, или группы получателей. Вы уверены, что хотите создать письмо / рассылку без получателей?
				</div>
                <div class="modal-controls">
                    <button @click="save" class="btn btn-lg btn-primary me-3">Сохранить и выйти</button>
                    <button @click="closeModal" class="btn btn-lg btn-outline-dark me-3">Отменить</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "NotificationModal",

    emits: ['closeModal', 'save'],
    methods: {
        closeModal: function() {
            this.$emit('closeModal');
        },
        save: function() {
            this.$emit('save');
        },
    },
}
</script>

<style scoped>

</style>
